module.exports = __webpack_public_path__ + "img/sms-message.2b3b8fde.svg";